module.exports = __webpack_public_path__ + "img/instagram.3ead050a.png";